"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _attach = _interopRequireDefault(require("../attach"));

var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _globals = _interopRequireDefault(require("mson/lib/globals"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = function styles(theme) {
  return {
    captcha: {
      margin: theme.spacing(1)
    }
  };
};

var ReCAPTCHAField = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(ReCAPTCHAField, _React$PureComponent);

  var _super = _createSuper(ReCAPTCHAField);

  function ReCAPTCHAField() {
    var _this;

    (0, _classCallCheck2.default)(this, ReCAPTCHAField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (value) {
      _this.props.component.setValue(value);
    });
    return _this;
  }

  (0, _createClass2.default)(ReCAPTCHAField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          editable = _this$props.editable,
          accessEditable = _this$props.accessEditable,
          classes = _this$props.classes,
          useDisplayValue = _this$props.useDisplayValue;
      var isEditable = accessEditable !== false && editable && !disabled;

      var siteKey = _globals.default.get('reCAPTCHASiteKey');

      if (isEditable && !useDisplayValue) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: classes.captcha
        }, /*#__PURE__*/_react.default.createElement(_reactGoogleRecaptcha.default, {
          ref: "recaptcha",
          sitekey: siteKey,
          onChange: this.handleChange
        }));
      } else {
        return null;
      }
    }
  }]);
  return ReCAPTCHAField;
}(_react.default.PureComponent);

ReCAPTCHAField = (0, _withStyles.default)(styles)(ReCAPTCHAField);

var _default = (0, _attach.default)(['disabled', 'editable', 'useDisplayValue'])(ReCAPTCHAField);

exports.default = _default;